import React, { useEffect, useState } from "react";
import HeaderAction from "../components/HeaderAction";
import styled from "styled-components";
import Tab from "../components/Tab";
import ListProduct from "../components/ListProduct";
import DetailProduct from "../../EventThingyan_2025/components/DetailProduct";
import { ID_PRIZE } from "../components/DefineData";
import iconBg1 from "../../../../assets/images/Event-2025/bg-icon-01.png";
import iconBg2 from "../../../../assets/images/Event-2025/bg-icon-2.png";
import { getCookie, getDataApi, postDataApi } from "../../../../config/service";
import API_PATH from "../../../../config/API_PATH";
import { curStateAccount, curStateMiniGame } from "../../../../Redux/selector";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import bgTakePrize from "../../../../assets/images/Mini-Game/bg-take-prize-web-x2.png";
import bgTakePrizeThadingyut from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/bg-take-prize-thadingyut-2025-theme.png";
import bgTakePrizeThadingyutPc from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/bg-take-prize-thadingyut-2025-theme-pc.png";
import bgTakePrizeNewYear from "../../../../assets/images/Mini-Game/new-year-2025/bg-take-prize.png";
import bgTakePrizeNewYearMobile from "../../../../assets/images/Mini-Game/new-year-2025/bg-take-prize-mobile.png";
import framePieceCollection from "../../../../assets/images/Mini-Game/Frame-piece-collection.png";
import framePieceCollectionThadingyut from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/Frame-piece-collection.png";
import framePieceCollectionNewYear from "../../../../assets/images/Mini-Game/new-year-2025/Frame-piece-collection.png";
import iconPiece from "../../../../assets/images/Mini-Game/delete-define-piece.png";
import pieceCollectionBtn from "../../../../assets/images/Mini-Game/piece-collection-btn.png";
import pieceCollectionBtnNewYear from "../../../../assets/images/Mini-Game/new-year-2025/piece-collection-btn.png";
import { Link } from "react-router-dom";
import PATH from "../../../../config/PATH";
import {
  ID_TAB_MINI_GAME,
  // IS_EVENT_THADINGYUT_2025_THEME,
  TYPE_GIVE_MINIGAME,
  TYPE_GIVE_PIECE,
  TYPE_REQUEST_PIECE,
  useNewYear2025Theme,
  useThadingyutTheme,
} from "../../../../helper/const";
import _ from "lodash";
import {
  confirmPieceLinkMiniGame,
  pieceLinkMiniGame,
  setDataPopupError,
  setOpenPopupGivePiece,
  setOpenPopupLogin,
} from "../../../../Redux/futures/mini-game/action";
import ModalNotifycation from "../../../../component/ModalNotifycation";
import { useTranslation } from "react-i18next";
import MiniGame from "../../../MiniGame";
import { mediaQueryPoint, useMediaQuery } from "../../../../utils/hooks";
import { useLoginModal } from '@/contexts/LoginModalContext';

export default function PieceCollection() {
  const selectorAccount = useSelector(curStateAccount);
  const dispatch = useDispatch();
  const dataMiniGame = useSelector(curStateMiniGame);
  const { id } = useParams();
  const [itemProductActive, setItemProductActive] = useState(id);
  const [dataAwardActive, setDataAwardActive] = useState([]);
  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`);
  const isPcSmall = useMediaQuery(
    `(min-width: ${mediaQueryPoint.lg}px) and (max-width: ${mediaQueryPoint.xxl}px)`
  );
  const IS_EVENT_THADINGYUT_2025_THEME = useThadingyutTheme();
  const IS_EVENT_NEW_YEAR_2025_THEME = useNewYear2025Theme();
  const { openLogin } = useLoginModal();

  const bgTakePrizeThadingyutTheme = isMobile
    ? bgTakePrizeThadingyut
    : bgTakePrizeThadingyutPc;

  const bgTakePrizeNewYearTheme = isMobile
    ? bgTakePrizeNewYearMobile
    : bgTakePrizeNewYear;

  useEffect(() => {
    if (_.isEmpty(dataMiniGame.dataAwardListMini)) {
      return;
    }
    if (!id || id === "piece-collection") {
      const dataSort = dataMiniGame.dataAwardListMini.sort(
        (a, b) => Number(a.rank) - Number(b.rank)
      );
      setItemProductActive(dataSort[0]?.id);
    }
  }, [dataMiniGame.dataAwardListMini]);

  const afterRequest = (data, isLoading, dataError) => {
    if (data && data?.data?.code) {
      dispatch(
        setOpenPopupGivePiece({
          isShow: true,
          link: `http://reverseauction.com.mm/mini-game/request/${data.data.code}`,
          type: TYPE_REQUEST_PIECE.requestLink,
        })
      );
    } else if (dataError) {
      dispatch(
        setDataPopupError({
          isOpen: true,
          message: "",
        })
      );
    }
  };

  const handleRequest = async (item = {}) => {
    // check user đăng nhập chưa
    // if (!selectorAccount.userInfo) {
    //   return dispatch(setOpenPopupLogin(true));
    // }
    if (!selectorAccount.userInfo) {
      return openLogin(() => handleRequest(item));
    }

    const dataApi = {
      type: TYPE_GIVE_MINIGAME.request,
      piece_id: item.id,
      callback: afterRequest,
      piece_number: 1,
    };
    dispatch(pieceLinkMiniGame(dataApi));
  };
  const handleGive = (item = {}) => {
    // check user đăng nhập chưa
    if (!item.num) {
      return null;
    }
    if (!selectorAccount.userInfo) {
      return dispatch(setOpenPopupLogin(true));
    }

    let awardName = "";
    const dataAwardListMini = dataMiniGame.dataAwardListMini || [];
    dataAwardListMini.forEach((itemAward) => {
      if (+itemAward.id === +item.minigame_award_id) {
        awardName = itemAward.name;
      }
    });

    dispatch(
      setOpenPopupGivePiece({
        isShow: true,
        link: "",
        data: { ...item, awardName },
        type: TYPE_GIVE_PIECE.give,
      })
    );
  };

  //
  const handleGetDataCollected = async () => {
    const dataApi = await getDataApi(API_PATH.miniGamePieceCollected, {
      award_id: itemProductActive,
    });
    setDataAwardActive(dataApi?.data);
    // setIsRunout(dataApi?.is_runout);
  };

  useEffect(() => {
    handleGetDataCollected();
  }, [itemProductActive]);
  const { t } = useTranslation();

  return (
    <MiniGame>
      <Div
        bg={
          IS_EVENT_THADINGYUT_2025_THEME
            ? bgTakePrizeThadingyutTheme
            : IS_EVENT_NEW_YEAR_2025_THEME
              ? bgTakePrizeNewYearTheme
              : bgTakePrize
        }
        className={`${IS_EVENT_THADINGYUT_2025_THEME
            ? "thadingyut-theme"
            : IS_EVENT_NEW_YEAR_2025_THEME
              ? "new-year-25-theme"
              : ""
          }`}
      >
        <Container className='container-thingyan container-minigame'>
          <div className='thingyan-home-header'>
            {!IS_EVENT_THADINGYUT_2025_THEME &&
              !IS_EVENT_NEW_YEAR_2025_THEME && (
                <>
                  <img src={iconBg1} alt='' className='icon-bg-web1' />
                  <img src={iconBg2} alt='' className='icon-bg-web2' />
                </>
              )}
            <div className='header-take-prize'>
              <HeaderAction />
            </div>
            <Tab idActive={2} itemProductActive={itemProductActive} />
            <ListProduct
              setItemProductActive={setItemProductActive}
              itemProductActive={itemProductActive}
            />
            {_.isEmpty(dataAwardActive) ? null : (
              <div className='piece-collection-content'>
                <Grid>
                  {dataAwardActive.map((item, index) => (
                    <GridItem
                      key={item.id}
                      className={`${IS_EVENT_THADINGYUT_2025_THEME ? "thadingyut-theme" : ""
                        } ${IS_EVENT_NEW_YEAR_2025_THEME ? "new-year-25-theme" : ""
                        }`}
                    >
                      <div className='count'>x{item.num || 0}</div>

                      <div className='grid-item-content'>
                        <div className='grid-item-img-container'>
                          <img
                            src={item.image_light || iconPiece}
                            alt=''
                            className='grid-item-img'
                          />
                        </div>

                        <div className='grid-item-info'>
                          <p>Piece {item.name}</p>
                          <div className='grid-item-action'>
                            <button
                              className='btn-request'
                              onClick={() => handleRequest(item)}
                            >
                              {t("mini_game.piece_collection.request")}
                            </button>
                            <button
                              className={`btn-give ${item.num ? "" : "card-disabled"
                                }`}
                              onClick={() => handleGive(item)}
                            >
                              {t("mini_game.piece_collection.give")}
                            </button>
                          </div>
                        </div>
                      </div>
                    </GridItem>
                  ))}
                </Grid>

                <Link
                  to={`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.home}`}
                  className={`${IS_EVENT_NEW_YEAR_2025_THEME ? "new-year-25-theme" : ""} btn-earn-more-piece`}
                >
                  {t("mini_game.piece_collection.earn_more_piece")}
                </Link>
              </div>
            )}
          </div>
        </Container>
      </Div>
    </MiniGame>
  );
}
const Div = styled.div`
  /* new */
  .container-thingyan .thingyan-home-header {
    background-image: url(${(props) => props.bg}) !important;

    @media (max-width: 600px) {
      background-position: center;
      background-size: 100% 100%;
    }
  }
  /* end new */
  .img-filter-event__2025 {
    filter: drop-shadow(0px 0px 1px white) drop-shadow(0px 0px 1px white)
      drop-shadow(0px 0px 2px white);
  }

  .text-default {
    -webkit-text-stroke: inherit !important;
    font-size: 26px !important;
  }

  &.thadingyut-theme {
    .container-thingyan .thingyan-home-header {
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 100% 100%;

      @media (min-width: 768px) and (max-width: 1400px) {
        background-size: 165% 100%;
      }

      @media (min-width: 1400px) and (max-width: 1600px) {
        background-size: 145% 100%;
      }
    }
  }

  &.new-year-25-theme {
    .container-thingyan .thingyan-home-header {
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;

      @media (min-width: 768px) and (max-width: 1400px) {
        background-size: cover;
      }

      @media (min-width: 1400px) and (max-width: 1600px) {
        background-size: cover;
      }
    }
  }
`;

const Container = styled.div`
  .header-take-prize {
    padding-top: 18px;
    margin-bottom: 30px;
  }

  .thingyan-home-header {
    overflow-y: hidden;
  }

  .piece-collection-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    max-width: 90%;
    gap: 32px;
    padding-top: 100px;
    padding-bottom: 32px;

    @media (max-width: 768px) {
      max-width: 100%;
    }

    @media (max-width: 592px) {
      padding-top: 70px;
    }

    @media (max-width: 525px) {
      padding-top: 50px;
    }

    @media (max-width: 425px) {
      padding-top: 30px;
    }

    @media (max-width: 375px) {
      padding-top: 20px;
    }

    .btn-earn-more-piece {
      background-image: url(${pieceCollectionBtn});
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center;
      color: #fff;
      font-size: 24px;
      font-weight: 700;
      padding: 20px;
      max-width: 560px;
      width: 100%;
      height: 72px;
      text-align: center;
      position: relative;
      z-index: 2;
      
      &.new-year-25-theme {
        background-image: url(${pieceCollectionBtnNewYear});
        text-shadow: -1px -1px 0 #00386F, 1px -1px 0 #00386F, -1px 1px 0 #00386F, 1px 1px 0 #00386F;
        border-radius: 99px;
        box-shadow: -5px 5px 20px 0px rgba(53, 18, 18, 0.6);
      }

      @media (max-width: 625px) {
        max-width: 460px;
        font-size: 18px;
      }

      @media (max-width: 525px) {
        max-width: 400px;
      }

      @media (max-width: 425px) {
        max-width: 350px;
        font-size: 20px;
        font-size: 16px;
        height: auto;
      }

      @media (max-width: 375px) {
        max-width: 300px;
      }
    }
  }

  @media (max-width: 576px) {
    .header-take-prize {
      padding-top: 10px;
      margin-bottom: 20px;
    }
  }

  @media (min-width: 1400px) {
    .header-take-prize {
      padding-top: 25px;
      padding-left: 22px;
      padding-right: 22px;
    }
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-top: 20px;
  padding: 0px 20px;
  justify-items: center;
  /* max-width: 80%; */
  margin: 0 auto;
  position: relative;
  z-index: 2;

  @media (max-width: 1600px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 525px) {
    /* padding: 0; */
    width: 100%;
  }

  @media (max-width: 475px) {
    row-gap: 20px;
    column-gap: 10px;
    padding: 0 10px;
  }
`;

const GridItem = styled.div`
  background-image: url(${framePieceCollection});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 282px;
  width: 269px;
  position: relative;

  &.thadingyut-theme {
    background-image: url(${framePieceCollectionThadingyut});
  }

  &.new-year-25-theme {
    background-image: url(${framePieceCollectionNewYear});

    .btn-request {
      background-color: #d61717 !important;
      color: #fff !important;

      &:hover {
        background-color: #ff0000 !important;
      }
    }

    .btn-give {
      background-color: #560909 !important;
      color: #fff !important;
      border: 1px solid #f3b9b9 !important;

      &:hover {
        background-color: #7a0f0f !important;
      }
    }
  }

  .card-disabled {
    pointer-events: none;
    opacity: 0.5;
    user-select: none;
  }
  .count {
    background: linear-gradient(
      180deg,
      rgba(255, 247, 180, 1) 0%,
      rgba(249, 122, 28, 1) 100%
    );
    text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff,
      1px 1px 0 #fff;
    height: 32px;
    width: 70px;
    border-bottom-left-radius: 18px;
    border-top-right-radius: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #c35b0b;
    font-size: 20px;
    font-weight: 800;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
  }

  .grid-item-content {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    height: 100%;
    position: relative;
    .grid-item-info {
      width: 100%;
    }

    .grid-item-img-container {
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      pointer-events: none;
    }

    .grid-item-img {
      margin: 0 auto;
      display: block;
      width: 150px;
      height: 150px;
      object-fit: contain;
    }

    p {
      font-size: 20px;
      font-weight: 800;
      color: #fff;
      text-shadow: -1px -1px 0 #c76216, 1px -1px 0 #c76216, -1px 1px 0 #c76216,
        1px 1px 0 #c76216;
      text-align: center;
      margin-bottom: 10px;
    }

    .grid-item-action {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      gap: 8px;

      .btn-request,
      .btn-give {
        width: 50%;
        background-color: #f97a1c;
        border-radius: 20px;
        font-weight: 600;
        color: #fff;
        border: none;
        height: 41px;
        font-size: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: background-color 0.3s;

        &:hover {
          background-color: #f89c00;
        }
      }

      .btn-give {
        background-color: #fff;
        color: #f97a1c;

        &:hover {
          background-color: #f0f0f0;
        }
      }
    }
  }

  @media (max-width: 625px) {
    background-size: 100% 100%;
    width: 220px;
    height: 220px;

    .grid-item-content {
      .grid-item-img {
        width: 100px;
        height: 100px;
      }

      .grid-item-action {
        .btn-request,
        .btn-give {
          font-size: 13px;
          padding: 0 2px !important;
        }
      }
    }
  }

  @media (max-width: 525px) {
    width: 100%;
    height: 190px;
    padding: 14px;
    /* padding-top: 14px; */
    .count {
      font-size: 16px;
      width: 55px;
    }

    .grid-item-content {
      /* .grid-item-img {
        width: 45%;
      } */
      p {
        font-size: 16px;
      }
      .grid-item-action {
        gap: 4px;

        .btn-request,
        .btn-give {
          font-size: 14px;
          padding: 8px 16px;
        }
      }
    }
  }

  @media (max-width: 475px) {
    height: 175px;

    .count {
      font-size: 14px;
      width: 45px;
    }

    .grid-item-content {
      .grid-item-img {
        width: 80px;
        height: 80px;
      }
      p {
        font-size: 14px;
      }
      .grid-item-action {
        gap: 4px;

        .btn-request,
        .btn-give {
          font-size: 12px;
        }
      }
    }
  }

  @media (max-width: 425px) {
    /* width: 175px; */
    /* height: 150px; */
  }

  @media (max-width: 375px) {
    width: 100%;

    .grid-item-content {
      .grid-item-img {
        width: 70px;
        height: 70px;
      }
      .grid-item-action {
        .btn-request,
        .btn-give {
          font-size: 10px;
          padding: 6px 12px;
        }
      }
    }
  }
`;
